import { connect } from 'react-redux'

const generateMapStateToProps = props => store => props.reduce( ( mapProps, name ) => ({ ...mapProps, [name]: store[ name ] }), { } )

export const ConnectReduxWith = ( ...props ) => DecoratedComponent => connect( generateMapStateToProps( props ) )( DecoratedComponent )

export default ConnectReduxWith